import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=d3dd8590&scoped=true&"
import script from "./ContactDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dd8590",
  null
  
)

export default component.exports